import React from 'react'
import type { CtxType } from './types/common'

/**
 * 允许外部使用 CtxContext 获取 ctx 实例
 *
 * @example
 *
 *  class Component extends React.Component {
 *    static contextType = CtxContext
 *    componentDidMount() {
 *      const ctx: CtxType = this.context
 *    }
 *  }
 */
export const CtxContext = React.createContext<CtxType>(
  (undefined as any) as CtxType
)

/**
 * 允许使用 hooks 获取 ctx 实例
 *
 * @example
 *  function Component(props) {
 *    const ctx = useCtx()
 *  }
 */
export const useCtx = function () {
  return React.useContext(CtxContext)
}
